import { prepareAndMakeRequest } from '@frontend/api';
import type {
  DeleteTeamMemberResponseBody,
  GetTeamMemberResponseBody,
  GetTeamMembersResponseBody,
  RequestQuery,
  ResendInviteRequestBody,
  ResendInviteResponseBody,
  SendInviteRequestBody,
  SendInviteResponseBody,
  SendSesVerificationRequestResponseBody,
  SesVerificationStatusResponseBody,
  UpdateTeamMemberRequestBody,
  UpdateTeamMemberResponseBody,
} from '@frontend/api';

import request from 'utils/request';

const transformTeamMemberToApi = (
  member: SendInviteRequestBody | UpdateTeamMemberRequestBody,
) => {
  if (member.isAdmin || !member.supplierRoles) member.supplierRoles = undefined;
  return member;
};

export default {
  invites: {
    resend: async (
      groupId: string,
      data: ResendInviteRequestBody,
    ): Promise<ResendInviteResponseBody> => {
      return await request.post<ResendInviteResponseBody>(
        `/users/groups/${groupId}/resend_invite`,
        data,
      );
    },
  },
  getTeamMembers: async (
    groupId: string,
    params?: RequestQuery,
  ): Promise<GetTeamMembersResponseBody> => {
    return await prepareAndMakeRequest.get<GetTeamMembersResponseBody>(
      `/suppliers/${groupId}/members`,
      {
        query: params,
      },
    );
  },
  getTeamMember: async (
    memberId: number | string,
  ): Promise<GetTeamMemberResponseBody> => {
    return await request.get<GetTeamMemberResponseBody>(
      `/suppliers/members/${memberId}`,
    );
  },
  deleteTeamMember: async (
    memberId: number,
  ): Promise<DeleteTeamMemberResponseBody> => {
    return await request.delete<DeleteTeamMemberResponseBody>(
      `/suppliers/members/${memberId}`,
    );
  },
  inviteTeamMember: async (
    groupId: string,
    data: SendInviteRequestBody,
  ): Promise<SendInviteResponseBody> => {
    return await request.post<SendInviteResponseBody>(
      `/users/groups/${groupId}/send_invite`,
      transformTeamMemberToApi(data),
    );
  },
  updateTeamMember: async (
    memberId: number,
    data: UpdateTeamMemberRequestBody,
  ): Promise<UpdateTeamMemberResponseBody> => {
    return await request.patch<UpdateTeamMemberResponseBody>(
      `/suppliers/members/${memberId}`,
      transformTeamMemberToApi(data),
    );
  },
  sendVerificationEmail: async (
    id: number,
  ): Promise<SendSesVerificationRequestResponseBody> => {
    return await request.post<SendSesVerificationRequestResponseBody>(
      `/users/${id}/send_ses_verification_request`,
    );
  },
  getIsEmailVerified: async (id: number): Promise<boolean> => {
    const response = await request.get<SesVerificationStatusResponseBody>(
      `/users/${id}/ses_verification_status`,
    );
    return response && response.verifiedInAwsSes;
  },
};
